import {defineStore} from "pinia";
import axios from "axios";
import {inspectionsListUrl, pingUrl} from "@/services/api";

export const useNetworkStore = defineStore('network', {
    state: () => ({
        online: false,
    }),
    getters: {
        isOnline: (state) => state.online,
    },
    actions: {
        setNetworkState: async function (isOnline: boolean) {
            if (isOnline) {
                const response = await axios.get(pingUrl);
                if (response.status !== 200 || response.data.status !== 'ok') {
                    this.online = false;
                    return;
                }
            }
            this.online = isOnline;
        }

    }
})
